import {EventEmitter, Injectable} from '@angular/core';
import {ApprovalModel} from '../dto/approval.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/index';
import {ApprovalPending} from '../dto/approval-pending';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class SuspendService {
  constructor(private httpClient: HttpClient, private appConfig: AppConfig) {
  }

  baseUrl: string =  this.appConfig.getConfig('BASE_URL') + 'api/';

  private headers;
  public model = new EventEmitter<NgbModal>();
  public closeModel: NgbModal;
  private headersJson = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8'});

  searchRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend/searchRequestData', data);
  }

  getAllRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend/getRequestData', data);
  }

  getAllReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend/getReturnRequest', data);
  }

  getAllDGReturnRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend/getDGReturnRequest', data);
  }

  searchPendingRequestData(data: ApprovalPending): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend/searchPendingRequests', data);
  }

  searchApplicantDetails(applicationId: number): Observable<Object> {
    return this.httpClient.get(this.baseUrl + 'suspend/getApplicantDetails/'+ applicationId);
  }

  approveRequeat(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend/approveRequest', approvalModel, {headers: this.headers});
  }

  getPendingVerificationRequests(approvalPending: ApprovalPending): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'suspend/getPendingRequests',approvalPending, {headers: this.headers});
  }

  getPendingAuthorizationRequests(approvalPending: ApprovalPending): Observable<Object>{
    return this.httpClient.post(this.baseUrl + 'suspend/getPendingAuthList',approvalPending, {headers: this.headers});
  }

  returnRequest(approvalModel: ApprovalModel): Observable<Object> {
    return this.httpClient.post(this.baseUrl + 'suspend/returnRequest', approvalModel, {headers: this.headers});
  }

  saveDocumentTypeAndDetails(details) {
    return this.httpClient.post<any>(this.baseUrl + 'suspend/saveDocumentDetails', details);
  }

  close() {
    this.closeModel.dismissAll();
  }
}
